import { useToast } from '../context/ToastContext';

// Convenience hook that exports the toast functions
export const useToastNotifications = () => {
  const { success, error, warning, info, showToast, clearToasts } = useToast();

  return {
    success,
    error,
    warning,
    info,
    showToast,
    clearToasts,
  };
};

export default useToastNotifications;
